import BaseRepository from './base.repository';

class FireBaseRepository extends BaseRepository {
  constructor() {
    super('/firebase');
  }

  subscribeToPushNotification(pushSubscription) {
    return this.client.post('/webpush/subscribe', pushSubscription, {
      noLoading: true,
      silent: true,
    });
  }

  unsubscribeFromPushNotification(pushSubscription) {
    const { noLoading, ...fcmToken } = pushSubscription;
    return this.client.post('/webpush/unsubscribe', fcmToken, {
      noLoading: noLoading ?? true,
      silent: true,
    });
  }
}

export default new FireBaseRepository();
